<template>
    <div>
        <button @click="toggleChat" class="smartpress-button flex items-center justify-center"> 
            <figure class="bg-primary !m-0 !flex !items-center !justify-end !rounded-t-lg !mr-2">
            <img
                :src="`${pluginUrl}/assets/smart-press-logo.png`"
                alt="Smartpress Logo"
                class="w-5"/>
            </figure>
            <span class="text-white !mr-2">{{ isChatVisible ? "SmartChat" : currentText }}</span>
        </button>
        <button @click="clearChatSession" class="clear-button tooltip tooltip-left" data-tip="Clear chat history" v-show="isChatVisible">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-10">
            <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
            </svg>
        </button>
        <button @click="toggleChat" class="close-button" v-show="isChatVisible">X</button>
        <div id="chat-container" class="n8n-chat smartpress-disabled" v-show="isChatVisible" :class="{ 'fade-in': isChatVisible, 'fade-out': !isChatVisible }">
            <!-- existing chat content -->
        </div>
    </div>
</template>

<script >
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import axios from 'axios'; // Import axios for API validation

export default {
    name: 'SmartChat',
    data() {
        return {
            pluginUrl: window.smartpress_vars.pluginUrl || '',
            chat: null,
            isChatVisible: false,
            phrases: [
                "Hello! I'm your SmartPress AI moderator.", 
                "Ask me anything about your website management.", 
                "I can retrieve and organize your website content.", 
                "Need fresh content? I can create posts, pages, and more.", 
                "How can I improve your WordPress experience?", 
                "Looking for help? I'm here to assist.", 
                "Have a question about your site? Just ask!",
                "Let me handle website moderation for you.",
                "I can manage posts, categories, plugins, and more!",
                "Effortless website management at your command.",
                "Tell me what you need—I'll handle the rest!",
                "Managing your WordPress site has never been easier.",
                "I can create, edit, and organize your content in seconds.",
                "I take care of the details, so you can focus on growth.",
                "I'll make your website maintenance a breeze.",
            ],
            currentText: 'SmartChat',
            typingInterval: null,
            // get custom fields from local storage
            customFields: JSON.parse(localStorage.getItem('smartpress_custom_fields')),
            isValidatingKey: false,
            validationMessage: '',
            wpUser: window.smartpress_wpUserData ? window.smartpress_wpUserData : {},
        };
    },
    mounted() {
        createChat({
            webhookUrl: 'https://node.10g8.com/webhook/c7393169-703f-4dd9-9be1-2fa0379915b7/chat',
            target: '#chat-container',
            mode: 'fullscreen',
            chatInputKey: 'chatInput',
            chatSessionKey: 'sessionId',
            metadata: {"api": this.customFields.api_key, "application_key": this.customFields.application_key, "website": this.customFields.site_url},
            showWelcomeScreen: false,
            defaultLanguage: 'en',
            initialMessages: [
                "Hello!👋 I'm your SmartPress AI moderator. I can manage posts, categories, plugins, and more!",
                "Tell me what you need, I'll handle the rest!"
            ],
            i18n: {
                en: {
                    title: '',
                    subtitle: "",
                    footer: 'Powered by SmartPress',
                    getStarted: 'New Conversation',
                    inputPlaceholder: 'Have a question about your site? Just ask!',
                },
            },
        });

        this.startShuffling();
        this.injectLogo();


        // if no application key, disable //*[@id="chat-container"]/main/div[3]/div/div/textarea
        if(!this.customFields.application_key){
            setTimeout(() => {
                try{
                    const chatBody = document.querySelector('#chat-container .chat-body');
                    // add opacity 0.5
                    chatBody.style.opacity = '0.5';
                    const chatInput = document.querySelector('#chat-container .chat-footer .chat-inputs textarea');
                    chatInput.disabled = true;
                    // update Input placeholder
                        chatInput.placeholder = 'Disabled. Application Key required to access your website.';

                        // Add div card that shows absolute center of the chat container with message and input field to add application password
                        const card = document.createElement('div');
                        card.classList.add('card');
                        card.classList.add('!bg-secondary');
                        card.classList.add('!text-white');
                        card.classList.add('!absolute');
                        card.classList.add('!top-1/2');
                        card.classList.add('!left-1/2');
                        card.classList.add('!transform');
                        card.classList.add('!-translate-x-1/2');
                        card.classList.add('!-translate-y-1/2');
                        card.classList.add('!p-4');
                        card.innerHTML = `<p>Please Add your Application password below to enable chat. <a class="!text-primary !no-underline" href="/wp-admin/profile.php">Create New Application Password.</a></p>
                        <div class="flex items-center mt-2">
                            <input type="text" placeholder="Application Password" class="app-key-input flex-grow">
                            <button class="paste-btn ml-2 px-2 py-1 bg-primary text-white rounded hover:bg-opacity-80">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                                    <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                                </svg>
                            </button>
                        </div>
                        <div class="validation-message mt-2 text-xs"></div>
                        <button class="save-btn mt-2 px-3 py-1 bg-green-600 text-white rounded hover:bg-opacity-80 disabled:opacity-50 disabled:cursor-not-allowed hidden">Save & Reload</button>
                        <small class="mt-2 opacity-80 text-xs !tooltip !tooltip-left" data-tip="We care about your privacy. We never store your application key, It's only being used when chating with AI and gets deleted instantly after each request.">Stored locally on your website.</small>
                        <div class="debug-info mt-3 text-xs hidden overflow-y-auto max-h-52 bg-gray-800 p-3 rounded"></div>
                        <button class="debug-toggle mt-3 text-xs py-1 px-2 bg-gray-700 hover:bg-gray-600 rounded transition-colors text-white">Show Debug Info</button>`;
                        chatInput.parentNode.parentNode.parentNode.parentNode.appendChild(card);
                        
                        // Add event listeners
                        const appKeyInput = card.querySelector('.app-key-input');
                        const pasteBtn = card.querySelector('.paste-btn');
                        const saveBtn = card.querySelector('.save-btn');
                        const validationMsg = card.querySelector('.validation-message');
                        const debugInfo = card.querySelector('.debug-info');
                        const debugToggle = card.querySelector('.debug-toggle');
                        
                        // Debug toggle
                        debugToggle.addEventListener('click', () => {
                            debugInfo.classList.toggle('hidden');
                            debugToggle.textContent = debugInfo.classList.contains('hidden') ? 
                                'Show Debug Info' : 'Hide Debug Info';
                        });
                        
                        // Save button
                        saveBtn.addEventListener('click', () => {
                            const key = appKeyInput.value;
                            // Format username:password correctly
                            let username = this.wpUser.user_login;
                            // let password = key;
                            
                            // Check if key itself contains a username
                            // if (key.includes(':')) {
                            //     const parts = key.split(':');
                            //     username = parts[0];
                            //     // password = parts[1];
                            // }
                            
                            // Store the application key with username prefix
                            this.customFields.application_key = key.includes(':') ? key : `${username}:${key}`;
                            localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
                            this.saveCustomFields();
                            
                            // Show success message and reload
                            validationMsg.textContent = 'Key saved! Reloading...';
                            validationMsg.style.color = '#ccffcc';
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        });
                        
                        // Paste button functionality
                        pasteBtn.addEventListener('click', async () => {
                            try {
                                const text = await navigator.clipboard.readText();
                                appKeyInput.value = text;
                                this.validateApplicationKey(appKeyInput.value, validationMsg, debugInfo);
                            } catch (err) {
                                console.error('Failed to read clipboard contents: ', err);
                            }
                        });
                        
                        // Input change event
                        appKeyInput.addEventListener('input', (e) => {
                            this.validateApplicationKey(e.target.value, validationMsg, debugInfo);
                        });
                } catch (err) {
                    console.error('Failed to add application key required. Please add your application key to enable chat. ', err);
                }
            }, 2000);
        }
    },
    methods: {
        toggleChat() {
            this.isChatVisible = !this.isChatVisible;
        },
        clearChatSession() {
            localStorage.removeItem('n8n-chat/sessionId');
            // Reload the chat component
            window.location.reload();
        },
        startShuffling() {
            // this.shuffleText();
            setInterval(
                () =>{
                    if(!this.isChatVisible){
                        this.shuffleText();
                    }
                }
            , 20000);
        },
        shuffleText() {
            const randomIndex = Math.floor(Math.random() * this.phrases.length);
            const newText = this.phrases[randomIndex];
            this.typeText(newText);
        },
        typeText(newText) {
            this.currentText = '';
            let index = 0;
            const typingSpeed = 30;

            clearInterval(this.typingInterval);

            this.typingInterval = setInterval(() => {
                if (index < newText.length) {
                    this.currentText += newText.charAt(index);
                    index++;
                } else {
                    clearInterval(this.typingInterval);
                    if(this.currentText != 'SmartChat'){
                        setTimeout(() => {
                            this.deTypeCurrentText();
                        }, 5000);
                    }
                }
            }, typingSpeed);
        },
        deTypeCurrentText() {
            const currentTextLength = this.currentText.length;
            let index = currentTextLength - 1;
            const deTypingSpeed = 10;

            const deTypingInterval = setInterval(() => {
                if (index >= 0) {
                    this.currentText = this.currentText.slice(0, index);
                    index--;
                } else {
                    clearInterval(deTypingInterval);
                    this.typeText('SmartChat');
                    // setTimeout(() => {
                    //     // this.currentText = 'SmartMod';
                    // }, 500);
                }
            }, deTypingSpeed);
        },
        injectLogo() {
            const chatHeader = document.querySelector('.chat-heading');
            if (chatHeader) {
                const img = document.createElement('img');
                img.src = this.pluginUrl + '/assets/smart-press-logo.png'; // Use the imported logo variable
                img.alt = 'Smartpress Logo';
                img.className = 'w-6';
                
                // Insert the image at the start of the chatHeader
                chatHeader.insertBefore(img, chatHeader.firstChild);
            }
        },
        async validateApplicationKey(key, validationMsgElement, debugElement) {
            const debugInfo = debugElement || document.querySelector('.debug-info');
            const saveBtn = document.querySelector('.save-btn');
            
            if (!key || key.length < 5) {
                validationMsgElement.textContent = 'Application key is too short';
                validationMsgElement.style.color = '#ffcccc';
                if (saveBtn) saveBtn.classList.add('hidden');
                return;
            }
            
            validationMsgElement.textContent = 'Validating...';
            validationMsgElement.style.color = '#ffffcc';
            
            // Remove spaces from the application password (WordPress shows with spaces but needs no spaces)
            let cleanedKey = key.replace(/\s+/g, '');
            
            // Format username:password correctly
            // Use a default username if wpUser is not available
            let username = 'smart'; // Default to smart since you mentioned this is your username
            if (this.wpUser && this.wpUser.user_login) {
                username = this.wpUser.user_login;
            }
            let password = cleanedKey;
            
            // Check if key itself contains a username
            if (cleanedKey.includes(':')) {
                const parts = cleanedKey.split(':');
                username = parts[0];
                password = parts[1];
            }
            
            // Update debug info
            if (debugInfo) {
                debugInfo.innerHTML = `
                <div class="p-3 border-b border-gray-600 mb-2">
                    <h3 class="font-bold !text-white mb-2 text-sm">Connection Info</h3>
                    <div class="grid grid-cols-[100px_1fr] gap-1">
                        <div class="text-gray-400">Site URL:</div>
                        <div class="font-mono">${this.customFields.site_url}</div>
                        <div class="text-gray-400">Username:</div>
                        <div class="font-mono">${username}</div>
                        <div class="text-gray-400">Password:</div>
                        <div class="font-mono opacity-50">${password}</div>
                        <div class="text-gray-400">Auth Header:</div>
                        <div class="font-mono">Basic ${btoa(`${username}:${password}`).substring(0, 10)}...</div>
                    </div>
                </div>`;
                
                // Scroll to top
                debugInfo.scrollTop = 0;
            }
            
            // Define endpoints to test
            const endpoints = [
                { 
                    url: '/wp-json/wp/v2/posts?per_page=1', 
                    name: 'Public Posts', 
                    requiresAuth: false,
                    description: 'Public endpoint - should work without auth'
                },
                { 
                    url: '/wp-json/wp/v2/pages?per_page=1', 
                    name: 'Pages', 
                    requiresAuth: true,
                    description: 'Page content - requires authentication'
                },
                { 
                    url: '/wp-json/wp/v2/types', 
                    name: 'Post Types', 
                    requiresAuth: true,
                    description: 'Post types endpoint - requires authentication'
                }
            ];
            
            let overallSuccess = false;
            let authenticatedEndpointSuccess = false;
            
            // Add endpoints section to debug
            if (debugInfo) {
                debugInfo.innerHTML += `
                <div class="p-3 border-b border-gray-600">
                    <h3 class="font-bold !text-white mb-2 text-sm">Endpoints Testing</h3>
                </div>`;
            }
            
            // Test each endpoint
            for (const endpoint of endpoints) {
                try {
                    validationMsgElement.textContent = `Testing ${endpoint.name} endpoint...`;
                    
                    const config = {
                        method: 'get',
                        url: `${this.customFields.site_url}${endpoint.url}`,
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        }
                    };
                    
                    // Add auth header for endpoints requiring authentication
                    if (endpoint.requiresAuth) {
                        config.headers['Authorization'] = `Basic ${btoa(`${username}:${password}`)}`;
                    }
                    
                    const response = await axios(config);
                    
                    if (response.status >= 200 && response.status < 300) {
                        if (debugInfo) {
                            debugInfo.innerHTML += `
                            <div class="p-3 mb-2 border-b border-gray-700">
                                <div class="flex items-start">
                                    <div class="text-green-300 mr-2 mt-1">✓</div>
                                    <div class="flex-1">
                                        <p class="font-bold">${endpoint.name}</p>
                                        <p class="text-xs text-gray-400">${endpoint.description}</p>
                                        <p class="text-xs mt-1">Status: <span class="text-green-300">${response.status} OK</span></p>
                                    </div>
                                </div>
                            </div>`;
                        }
                        
                        // Mark authenticated endpoint as successful
                        if (endpoint.requiresAuth) {
                            authenticatedEndpointSuccess = true;
                        }
                        
                        // If this is the pages endpoint, show page information
                        if (endpoint.url === '/wp-json/wp/v2/pages?per_page=1' && response.data && response.data.length > 0) {
                            if (debugInfo) {
                                debugInfo.innerHTML += `
                                <div class="px-4 py-3 bg-gray-700 rounded-md mb-3 mx-3">
                                    <p class="text-green-300 font-bold">Page Details</p>
                                    <p class="mt-1">Title: ${response.data[0].title?.rendered || 'Untitled'}</p>
                                    <p class="text-xs mt-1 text-gray-300">ID: ${response.data[0].id}</p>
                                    <p class="text-xs mt-1 text-gray-300">Status: ${response.data[0].status}</p>
                                </div>`;
                            }
                        }
                        
                        // If this is the types endpoint, show available post types
                        if (endpoint.url === '/wp-json/wp/v2/types' && response.data) {
                            const types = Object.keys(response.data).slice(0, 5); // Show only first 5 types
                            if (debugInfo) {
                                debugInfo.innerHTML += `
                                <div class="px-4 py-3 bg-gray-700 rounded-md mb-3 mx-3">
                                    <p class="text-green-300 font-bold">Post Types</p>
                                    <div class="flex flex-wrap gap-2 mt-2">
                                        ${types.map(type => `<span class="px-2 py-1 bg-gray-600 rounded-full text-xs">${type}</span>`).join('')}
                                    </div>
                                </div>`;
                            }
                        }
                    }
                } catch (error) {
                    if (debugInfo) {
                        debugInfo.innerHTML += `
                        <div class="p-3 mb-2 border-b border-gray-700">
                            <div class="flex items-start">
                                <div class="text-red-300 mr-2 mt-1">✗</div>
                                <div class="flex-1">
                                    <p class="font-bold">${endpoint.name}</p>
                                    <p class="text-xs text-gray-400">${endpoint.description}</p>
                                    <p class="text-xs mt-1">Status: <span class="text-red-300">${error.response ? error.response.status : 'Network Error'}</span></p>
                                    <p class="text-xs mt-1">${error.response ? error.response.statusText : error.message}</p>
                                </div>
                            </div>
                        </div>`;
                    }
                }
                
                // Scroll to bottom after each test
                if (debugInfo) {
                    debugInfo.scrollTop = debugInfo.scrollHeight;
                }
            }
            
            // Final validation result
            if (authenticatedEndpointSuccess) {
                validationMsgElement.textContent = 'Authentication successful! Click Save to continue.';
                validationMsgElement.style.color = '#ccffcc';
                overallSuccess = true;
                console.log('Authentication successful!', overallSuccess);

                // Show save button
                if (saveBtn) {
                    saveBtn.classList.remove('hidden');
                }
                
                if (debugInfo) {
                    debugInfo.innerHTML += `
                    <div class="p-3 mt-2 bg-green-900 bg-opacity-20 rounded-md border border-green-700 mx-3">
                        <p class="text-green-300 text-center font-bold">✓ Validation Successful</p>
                        <p class="text-center text-xs mt-1">Click Save to store your application key</p>
                    </div>`;
                    
                    // Scroll to bottom for result
                    debugInfo.scrollTop = debugInfo.scrollHeight;
                }
            } else {
                // Show save button for manual override
                if (saveBtn) {
                    saveBtn.classList.remove('hidden');
                    saveBtn.textContent = 'Force Save & Reload';
                }
                
                if (debugInfo) {
                    debugInfo.innerHTML += `
                    <div class="p-3 mt-2 bg-yellow-900 bg-opacity-20 rounded-md border border-yellow-700 mx-3">
                        <p class="text-yellow-300 text-center font-bold">⚠ Validation Incomplete</p>
                        <p class="text-center text-xs mt-1">You can still save if you believe the key is correct</p>
                    </div>`;
                    
                    // Scroll to bottom for result
                    debugInfo.scrollTop = debugInfo.scrollHeight;
                }
                
                validationMsgElement.textContent = 'Authentication check incomplete. You can still save this key.';
                validationMsgElement.style.color = '#ffcccc';
            }
        },
        async saveCustomFields() {
      console.log("Saving custom fields",this.customFields);
      this.saving = true;
      this.error = null;
      this.saveSuccess = false;
      
      try {
        const response = await fetch(`/wp-json/smartpress/v1/custom-fields`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': window.smartpress_wpApiSettings?.nonce || ''
          },
          body: JSON.stringify(this.customFields)
        });
        
        if (!response.ok) {
          throw new Error('Failed to save custom fields');
        }
        console.log(response);
        
        const data = await response.json();
        this.customFields = data;
        // Add to local storage
        localStorage.setItem('smartpress_custom_fields', JSON.stringify(this.customFields));
        this.saveSuccess = true;
        
        // Hide success message after 3 seconds
        setTimeout(() => {
          this.saveSuccess = false;
        }, 3000);
      } catch (error) {
        console.error('Error saving custom fields:', error);
        this.error = 'Failed to save custom fields. Please try again later.';
      } finally {
        this.saving = false;
      }
    },
    },
    watch: {
        isChatVisible(newVal) {
            if(newVal){
                this.currentText = 'SmartChat';
            }
        }
    }
}
</script>

<style>
.smartpress-button {
    background-color: #FF6266;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 5px 8px;
    cursor: pointer;
    position: fixed;
    right: 10px;
    bottom: 10px;
    z-index: 1001;
}

.close-button {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    font-size: 12px;
    cursor: pointer;
    position: fixed;
    right: 30px;
    bottom: 610px;
    z-index: 1001;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    transition: all 0.3s ease-in-out;
}
.close-button:hover{
    background: rgba(255, 255, 255, 0.4);
    scale: 1.1;
}

.clear-button {
    padding: 3px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    font-size: 12px;
    cursor: pointer;
    position: fixed;
    right: 55px;
    bottom: 610px;
    z-index: 1001;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-in-out;
}
.clear-button:hover {
    background: rgba(255, 255, 255, 0.4);
    scale: 1.1;
}

#chat-container {
    background-color: #fff;
    position: fixed;
    right: 10px;
    bottom: 50px;
    width: 400px;
    height: 600px;
    border-radius: 20px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
    z-index: 1000;
    transition: opacity 0.5s ease, transform 0.5s ease;
    transform: translateY(0);
}

#chat-container.fade-out {
    opacity: 0;
    transform: translateY(20px);
}

#chat-container.fade-in {
    opacity: 1;
    transform: translateY(0);
}

#chat-container .chat-layout{
    border-radius: 20px;
}
#chat-container .chat-header{
    gap: 0px !important;
}
#chat-container .chat-header p{
    margin: 0px;
    /* margin-top: 5px; */
}
.chat-message-markdown{
    font-size: 100% !important;
}

.chat-message-markdown ol{
    margin-left: 2em !important;
}
.chat-heading {
    justify-content: flex-start !important;
}
.chat-message-markdown p,.chat-heading h1{
    margin: 0.25rem !important;
}



#chat-container textarea{
   color: #000 !important;
}

#chat-container .chat-powered-by{
    display: none;
}

.chat-message-markdown blockquote {
    border-left-color: #FF6266 !important;
    margin: 0;
    padding-left: 0;
    font-size: 12px;
}

.chat-message-markdown {
    font-size: 12px !important;
}
</style>


